import React from 'react';

const CTAWhatsApp = () => {
  const handleWhatsAppClick = () => {
    const whatsappURL = 'https://api.whatsapp.com/send?phone=5575999481498&text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20a%20Paradise%20Formaturas.';
    window.open(whatsappURL, '_blank');
  };

  return (
    <section className="cta-whatsapp">
      <div className="container">
        <div className="cta-content" data-aos="zoom-in">
          <h2>Pronto para realizar o sonho da sua turma?</h2>
          <p>Entre em contato conosco e vamos criar juntos uma formatura inesquecível!</p>
          <button className="whatsapp-btn" onClick={handleWhatsAppClick}>
            <i className="fab fa-whatsapp"></i>
            Fale Conosco via WhatsApp
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTAWhatsApp;